<template>
  <section class="proposal">


    <div v-if="!ready && !loadingError">
      <loader></loader>
    </div>
    <page-error-iquote-not-found v-else-if="notFound"></page-error-iquote-not-found>

    <page-error v-else-if="error"></page-error>
    <page-error-iquote-not-correct v-else-if="dataError"></page-error-iquote-not-correct>
    <page-error-iquote-not-available v-else-if="!loadingError && !isAvailable"></page-error-iquote-not-available>
    <div v-else>
      <div class="container container-full-width-small px-0">
        <router-view></router-view>
      </div>
    </div>
  </section>
</template>

<script>
import PageErrorIquoteNotFound from '@/components/main/error/PageErrorIquoteNotFound'
import PageError from '@/components/main/error/PageError'
import PageErrorIquoteNotCorrect from '@/components/main/error/PageErrorIquoteNotCorrect'
import PageErrorIquoteNotAvailable from '@/components/main/error/PageErrorIquoteNotAvailable'
import { mapGetters } from 'vuex'

function insertGTMScript(w, d, s, l, i) {
  w[l] = w[l] || []
  w[l].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  })
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != 'dataLayer' ? '&l=' + l : ''
  j.async = true
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
  f.parentNode.insertBefore(j, f)
}

export default {
  name: 'proposal',
  components: {
    PageErrorIquoteNotFound,
    PageErrorIquoteNotAvailable,
    PageError,
    PageErrorIquoteNotCorrect
  },
  mounted() {
    const iquoteId = this.$route.params.iquoteId

    this.$store.commit('SET_IQUOTE_ID', iquoteId)
    this.setQuoteIdIfKnown()
    // first, getIquote
    this.$store.dispatch('getIquote').then((iquoteRes) => {
      if (iquoteRes) {
        // push locale to dataLayer GTM
        window.dataLayer.push({
          pageLanguage: iquoteRes.locale,
        })
        if (
          window.location.origin.slice(-2) === 'be' &&
          iquoteRes.configurationId.match(/engie/i)
        ) {
          // insert GTM script for ENGIE Belgium
          insertGTMScript(window, document, 'script', 'dataLayer', 'GTM-TGZQTNX')
        }
      }
    })
  },
  computed: {
    ...mapGetters(['isAvailable', 'isOpenRedesign', 'loadingError']),
    notFound() {
      return this.loadingError === 'NOT_FOUND'
    },
    error() {
      return this.loadingError === 'ERROR'
    },
    dataError() {
      return this.loadingError === 'DATA_ERROR'
    },
    ready() {
      return this.$store.getters.iquote
    },
    routeParams() {
      return this.$route.params
    },
    orderPlaced() {
      return this.$store.getters.iquote && this.$store.getters.iquote.orderPlaced
    },
    failedOrOpenPayment() {
      const status = this.$store.getters.iquote.paymentStatus
      return ['FAILED', 'OPEN'].includes(status)
    },
    paidPayment() {
      const status = this.$store.getters.iquote.paymentStatus
      return status === 'PAID'
    },
  },
  methods: {
    setQuoteIdIfKnown() {
      if (this.$route.params.hasOwnProperty('id')) {
        this.$store.commit('SET_QUOTE_ID', this.$route.params.id)
      }
    },
  },
  watch: {
    ready(b) {
      if (!b) return

      if ((this.orderPlaced || this.paidPayment) && !this.isOpenRedesign) {
        if (!this.$route.name.includes('Order'))
          this.$router.push({
            name: 'Order',
          })
      } else if (this.failedOrOpenPayment && this.$store.getters.iquote.chosenQuoteId) {
        if (!this.$route.name.includes('OrderSummary'))
          this.$router.push({
            name: 'OrderSummary',
            params: {
              id: this.$store.getters.iquote.chosenQuoteId,
              paymentError: true,
            },
          })
      } else if (this.$route.name === 'Order') {
        this.$router.push(`/iquote/${this.iquote.id}`)
      }
    },
    routeParams() {
      this.setQuoteIdIfKnown()
    },
  },
}
</script>
